
function clearSuggester(theID)
{
	let nameInput = $("#" + theID + "Name");
	let idInput = $("#" + theID + "Name_PK_");
	nameInput.val("");
	idInput.val("0");
}

function hideVersionSuggesters() {
	$('#_versionDiscoveredName_').hide();
	$('#_versionPlanSolutionName_').hide();
	$('#_versionResolvedName_').hide();
}
const	STATE_SOLVED = "3sol";
const	STATE_SOLVED_CHECKED = "chck";

function showVersionSuggesters() {
	$('#_versionDiscoveredName_').show();
	const s = $('#state').val();
	if (s === STATE_SOLVED || s === STATE_SOLVED_CHECKED) {
		$('#_versionPlanSolutionName_').hide();
		$('#_versionResolvedName_').show();
	} else {
		$('#_versionPlanSolutionName_').show();
		$('#_versionResolvedName_').hide();
	}
}

function clearVersionSuggesters() {
	clearSuggester('versionDiscovered');
	clearSuggester('versionPlanSolution');
	clearSuggester('versionResolved');
}

export function loadVersions()
{
	let comp = $('#component').val();
	if (comp === '') {
		clearVersionSuggesters();
		hideVersionSuggesters();
		return;
	}
	showVersionSuggesters();
}

export function stateChanged() {
	let comp = $('#component').val();
	if (comp !== '') showVersionSuggesters();
}

window.versionSuggesterParams = function() {
	let comp = $('#component').val();
	if (comp.length === 0) return "component=0";
	return "component="+comp;
}